import { Group } from "@mantine/core"
import { FilterBuilder } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { FindCertificatesByOrganizationIdRequestFiltersDto } from "~/gen/api"
import { useGetCertificatesFiltersOptions } from "~/pages/Brand/Certificates/hooks/useGetCertificatesFiltersOptions"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesFilters = () => {
  const { t } = useTranslation(["certificates"])
  const { filters, setFilters, view } = useCertificatesTableContext()

  const options = useGetCertificatesFiltersOptions({ view })

  return (
    <Group>
      <FilterBuilder<FindCertificatesByOrganizationIdRequestFiltersDto>
        filters={filters}
        title={t("filters.title")}
        searchPlaceholder={t("filters.search.placeholder")}
        setFilters={setFilters}
        options={options}
      />
    </Group>
  )
}
